var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M37.31 26.832c0 9.17-6.155 16.708-13.988 17.5-7.833-.768-13.989-8.306-13.989-17.5s6.2-16.756 14.077-17.5c7.789.84 13.923 8.354 13.923 17.524l-.022-.024z",
    fill: "url(#gc4mrz5pca)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M15.277 26.711c0-7.963 5.754-14.716 16.874-16.943-.084 0-3.53 0-.224-.024-.225-.025-.393-.122-.618-.194-.337-.049-.702-.073-1.04-.121-3.806-.097-.224-.073-.308-.097-12.44 1.646-19.458 8.81-19.458 17.379 0 9.15 4.673 14.338 18.293 15.257.477-.12.955-.266 1.404-.387-11.991-1.84-14.951-6.495-14.951-14.87h.028z",
    fill: "url(#qh8ondb0qb)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.413 47.435 38.5 38.5m4.993-12.087c0 9.433-7.647 17.08-17.08 17.08-9.433 0-17.08-7.647-17.08-17.08 0-9.433 7.647-17.08 17.08-17.08 9.433 0 17.08 7.647 17.08 17.08z",
    stroke: "url(#2scf8ym09c)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gc4mrz5pca",
    x1: 9.333,
    y1: 29.685,
    x2: 38.115,
    y2: 22.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "qh8ondb0qb",
    x1: 10.503,
    y1: 28.311,
    x2: 33.209,
    y2: 23.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2scf8ym09c",
    x1: 9.333,
    y1: 31.49,
    x2: 47.124,
    y2: 19.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EC234"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/emptySearch.e46872b7b93ad1c9d6776e6151cb54f2.svg";
export { ForwardRef as ReactComponent };